// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"18652341","875":"b37fad64","970":"040be366"}[chunkId] + ".chunk.js";
};